import { mpx } from '@didi/es-mpx-creator'
import { getStorageSync } from '@/utils/storage'
import { get, post } from '../index'

const FLIGHTS_PREFIX = 'flights' // tc机票
const MERAK_FLIGHTS_PREFIX = 'https://merak-flight.xiaojukeji.com' // 1期机票

const GET_ALL_CITYS = `/${FLIGHTS_PREFIX}/flight-api/get_all_citys`
const GET_AIRPORTS_BY_KEYWORD = `/${FLIGHTS_PREFIX}/flight-api/get_airports_by_keyword`

// 特价机票
const GET_DISCOUNT_TICKETS = `${MERAK_FLIGHTS_PREFIX}/search-api/one_way/get_discount_price_list`
// 机票搜索按钮营销文案
const GET_FLIGHTS_BANNER_TEXT = `${MERAK_FLIGHTS_PREFIX}/activity-api/base/get_banner`
// 机票价格日历
const GET_CALENDAR_PRICE = `${MERAK_FLIGHTS_PREFIX}/search-api/one_way/get_price_calender`
// 机票优惠券
const GET_FLIGHT_COUPON_LIST = `${MERAK_FLIGHTS_PREFIX}/activity-api/auth/coupon/query_coupon_list`
const RECEIVE_FLIGHT_COUPON = `${MERAK_FLIGHTS_PREFIX}/activity-api/auth/coupon/obtain_coupon`

export const getFlightsBannerText = params => {
  return get(GET_FLIGHTS_BANNER_TEXT, params)
}

export const getCalendarPrice = data => {
  return post(GET_CALENDAR_PRICE, data)
}

// 获取全量城市列表
export const getAllFlightsCitys = () => {
  return mpx.$http.get(GET_ALL_CITYS)
}

// 根据城市/机场关键字获取机场列表
export const getAirportsByKeyword = params => {
  return mpx.$http.get(GET_AIRPORTS_BY_KEYWORD, {
    params,
  })
}

// 特价机票推荐
export const getDiscountTickets = params => {
  return get(GET_DISCOUNT_TICKETS, params)
}

// 获取机票优惠券列表
export const getFlightCouponList = params => {
  return get(GET_FLIGHT_COUPON_LIST, params)
}

// 领取机票优惠券
export const receiveFlightCoupon = data => {
  return post(RECEIVE_FLIGHT_COUPON, data)
}
